import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.482 3.22a6.865 6.865 0 00-5.7-1.419 6.818 6.818 0 00-2.78 12.089 11.553 11.553 0 012.97 3.194l.53.882a.758.758 0 001.298 0l.509-.847a9.635 9.635 0 012.71-3.03 6.81 6.81 0 00.464-10.873v.004zm-4.332 8.296a3.03 3.03 0 110-6.06 3.03 3.03 0 010 6.06z"
        fill={props.color ?? "#23262F"}
      />
    </svg>
  );
}

export default SvgComponent;
